import { Md5 } from 'ts-md5';
import Service from "./Service"

export default class WiypService extends Service {
	constructor() {
		super()
		this.serviceUrl = `https://api.travelski.com/wiyp`
		this.mandatoryFields = {
			getWiypPrices: [
				"packageId",
				"packCode",
				"liheId",
				"prestIds",
				"startDate",
				"endDate",
				"familyComposition",
				"site",
				"acceptLanguage",
			],
		}
	}
	
	async getWiypPrices(requestData) {
        
        this.checkMandatoryFields(requestData, "getWiypPrices")
		if (requestData.packCode === "HS")
			throw new Error("cannot request prices for HS package")
		const headers = {
			"content-type": "application/json",
			"accept-language": requestData.acceptLanguage,
			"site": "TS",
		}

		const query = {
			packageId: requestData.packageId,
			packCode: requestData.packCode,
			liheId: requestData.liheId,
			prestIds: requestData.prestIds,
			startDate: requestData.startDate,
			endDate: requestData.endDate,
			familyComposition: requestData.familyComposition,
			site: requestData.site,
			acceptLanguage: requestData.acceptLanguage
		};
		const orderedQuery = Object.keys(query).sort().reduce((obj, key) => {
			if (query[key] !== null && query[key] !== undefined && query[key] !== '') {
				obj[key] = query[key];
			}
			return obj;
		}, {});
		const hashKey = Md5.hashStr(JSON.stringify(orderedQuery));

		const queryString = Object
			.keys(orderedQuery)
			.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(orderedQuery[key])}`)
			.join('&');
		
		// ONLY FOR METRICS
		// HERE WE MAKE THE CALL AND DO NOT CARE ABOUT ANSWER
		// console.log('CALL TO WIYP ENDPOINT', hashKey);
		const { data } = await this.axios.get(`${this.serviceUrl}/price/${hashKey}?${queryString}`);
		return data
	}



}
